import { API_URL } from "./helper";

export const config = {
  URL: {
    //Previlage API
    FETCH_ALL_USER: `${API_URL}/golumbia_api/user/get-all-user`,
    FETCH_USER_BY_ID: `${API_URL}/golumbia_api/user/get-user?userId=`,
    CREATE_USER: `${API_URL}/golumbia_api/user/create-user`,
    UPDATE_USER: `${API_URL}/golumbia_api/user/update-user`,
    DELETE_USER: `${API_URL}/golumbia_api/user/delete-user/userId=`,
    ADD_PERMISSION: `${API_URL}/golumbia_api/privilege/add-permission`,

    //Vehicle API
    FETCH_ALL_VEHICLE: `${API_URL}/golumbia_api/vehicle/get-all-vehicles`,
    FETCH_ALL_VEHICLE_BY_MENU: `${API_URL}/golumbia_api/vehicle/get-all-vehicles-by-menu?menu=`,
    CREATE_VEHICLE: `${API_URL}/golumbia_api/vehicle/create-new-vehicle`,
    DELETE_VEHICLE: `${API_URL}/golumbia_api/vehicle/delete-vehicle?vehicleId=`,
    REMOVE_VEHICLE: `${API_URL}/golumbia_api/vehicle/remove-vehicle?vehicleId=`,
    UPDATE_VEHICLE: `${API_URL}/golumbia_api/vehicle/update-vehicle`,

    //Route API
    FETCH_ALL_ROUTE: `${API_URL}/golumbia_api/location/get-all-location`,
    CREATE_ROUTE: `${API_URL}/golumbia_api/location/create-route`,
    DELETE_ROUTE: `${API_URL}/golumbia_api/location/delete-route?routeId=`,
    UPDATE_ROUTE: `${API_URL}/golumbia_api/location/update-route`,
    GET_ROUTE_BY_MENU: `${API_URL}/golumbia_api/location/get-all-location-by-menu?menu=`,
    ADD_WAY_POINT: `${API_URL}/golumbia_api/location/add-way-point`,
    REMOVE_WAY_POINT: `${API_URL}/golumbia_api/location/remove-way-point?locationId=`,
    DELETE_WAY_POINT: `${API_URL}/golumbia_api/location/delete-way-point?locationId=`,
    UPDATE_WAY_POINT: `${API_URL}/golumbia_api/location/update-way-point`,

    //User API
    GET_USER_TOKEN: `${API_URL}/golumbia_api/user/get-user-token`,

    //Google API
    GOOGLE_MAP_API: `https://maps.googleapis.com/maps/api/place/autocomplete/json`,
  },
};
